import axios from 'axios';

class AuthService {

    login(dshash) {
        return axios
            .post(process.env.VUE_APP_ROOT_EVENTOS_API + '/auth/signin', {
                dsHash: dshash
            })
            .catch(function () {
            })
            .then(response => {
                if (response.data.bearerToken) {
                    localStorage.setItem('user_eventos', JSON.stringify(response.data.bearerToken));
                }
                return response.data;
            });
    }
    logout() {
        localStorage.clear();
        setTimeout(function () {
            window.location.href = "https://gnp.net.br";
        }, 3000);
    }
}

export default new AuthService();